import { Auditoria } from "../service/auditoria";
import { AuditoriaService } from "../../seguridad/services/auditoria.service";

export class AuditoriaClass {
  constructor(private auditoriaService: AuditoriaService) { }
    guardarAuditoria(modulo, opcion, mensaje, nrodocumento) {
        let auditoria = new Auditoria();
        auditoria.modulo = modulo;
        auditoria.opcion = opcion;
        auditoria.mensaje = mensaje;
        auditoria.nrodocumento = nrodocumento;
        this.auditoriaService.guardarAuditoria(auditoria).then(res => {

        }).catch(err => {
          console.log(err);
        });
      }
}
export class AuditoriaNavegacionClass {
  constructor(private auditoriaService: AuditoriaService) { }
    guardarAuditoriaNavegacion(IdUsuario, modulo, opcion, accion, mensaje) {
        const storedData = JSON.parse(localStorage.getItem('objSesionUsuarioLogeado'));
        const auditoria = new Auditoria();
        auditoria.IdUsuario = storedData.idusuario;
        auditoria.modulo = modulo;
        auditoria.opcion = opcion;
        auditoria.accion = accion;
        auditoria.mensaje = mensaje;
        this.auditoriaService.guardarAuditoriaNavegacion(auditoria).then(res => {
        }).catch(err => {
          console.log(err);
        });
      }
    /*INICIO: INE(EGB) 20220714 - REQ22111*/
    guardarLogErrorPortal(IdCliente, documento,mensaje) {
        const auditoria = new Auditoria();
        auditoria.IdCliente = IdCliente;
        auditoria.documento = documento;
        auditoria.mensaje = mensaje;
        this.auditoriaService.guardarLogErrorPortal(auditoria).then(res => {
        }).catch(err => {
          console.log(err);
        });
      }
    /*FIN: INE(EGB) 20220714 - REQ22111*/
}
